import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MyBrands from '../../components/blocks/MyBrands';
import {
  getAdminBrandsSuppliers,
  getAdminBrandsInvitation,
  adminBrandsAcceptInvitation,
} from '../../store/actions/adminBrands';
import { AnalyticsSpinner } from '../../components/common/Spinner/AnalyticsSpinner';
import AcceptInvitationModal from '../../components/blocks/AcceptInvitationModal';

function MyBrandsContainer(props) {
  const { getSuppliers, getInvitations } = props;

  const [open, setOpen] = useState(false);
  const [supplier, setSupplier] = useState({});

  useEffect(() => {
    getSuppliers();
    getInvitations();
  }, [getSuppliers, getInvitations]);

  const openModal = (supplier) => {
    setOpen(true);
    setSupplier(supplier);
  };

  if (props.isLoading) {
    return <AnalyticsSpinner fullScreen />;
  }

  return (
    <>
      <AcceptInvitationModal
        supplier={supplier}
        open={open}
        onClose={() => setOpen(false)}
        acceptInvitation={props.acceptInvitation}
      />

      <MyBrands
        retailerId={props.retailerId}
        suppliers={props.suppliers}
        invitations={props.invitations}
        openAcceptInvitationModal={openModal}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  const { retailerId } = state.role;
  const { suppliers, invitations, isLoading } = state.adminBrands;

  return {
    isLoading,
    suppliers,
    invitations,
    retailerId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSuppliers: () => dispatch(getAdminBrandsSuppliers()),
  getInvitations: () => dispatch(getAdminBrandsInvitation()),
  acceptInvitation: (data) => dispatch(adminBrandsAcceptInvitation(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyBrandsContainer);

MyBrandsContainer.propTypes = {
  getSuppliers: PropTypes.func.isRequired,
  getInvitations: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  acceptInvitation: PropTypes.func.isRequired,
  retailerId: PropTypes.number.isRequired,
};
